import { useGetUsersPreferencesPipeSeries } from "@imi/api-client/index.js";
import { useTranslation } from "react-i18next";
import { useQueryState } from "./queries/useQueryState";

export function usePipeSeriesPreference() {
  const { t } = useTranslation("settings", { keyPrefix: "pipeSeries" });
  return useQueryState(
    useGetUsersPreferencesPipeSeries(),
    t("errors.fetchUnknown"),
  );
}
